<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.receiptCaseFinesFees.table.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.receiptCaseFinesFees.table.description') }}
    </v-card-subtitle>
    <v-card-text class="pa-0 mt-n4">
      <v-data-table
        :items="cases"
        :headers="headers"
        class="mt-2"
        item-key="caseHeader.caseInstanceUUID"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="800">
        <template #item.caseHeader.courtID="{ value }">
          {{ getCourtByExternalID(value).displayName }}
        </template>
        <template #item.caseHeader.filedDate="{ value }">
          {{ value | formatDate }}
        </template>
        <template #item.caseHeader.caseNumber="{ item }">
          <router-link :to="getCaseViewLink(item)">
            {{ item.caseHeader.caseNumber }}
          </router-link>
        </template>
      </v-data-table>
    </v-card-text>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import { useApplicationStore } from '@/stores/applicationStore';

const applicationStore = useApplicationStore();

export default {
  props: {
    receiptID: {
      type: String
    }
  },
  data () {
    return {
      loading: true,
      cases: [] // using a table display for consistency with other receipt types, though there will only be one case
    };
  },
  created () {
    let query = {
      receiptID: this.receiptID,
      fields: '*,court(*)',
      size: this.CONST.PAGING_MAX_SIZE
    };
    let url = this.$cove.getAPI({ name: 'api.caseFeePayments', query });

    // first we have to get the case fee payment record
    axios.get(url)
      .then((response) => {
        let caseFeePayments = _.get(response, 'data._embedded.results', []);
        if (caseFeePayments.length > 0)
        {
          // then we can extract the caseUUID from it and query for the case data
          let cfp = caseFeePayments[0];
          let caseUUID = cfp.caseIdentifier;
          let courtID = applicationStore.getCourtByExternalID(cfp.court.externalIdentifier).resourceID;
          let caseURL = this.$cove.getAPI({ name: 'api.court.case', params: { courtID, caseUUID } });
          return axios.get(caseURL)
            .then((response) => {
              this.cases = [_.defaultTo(response.data, {})];
            });
        }
        else
        {
          return null;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    headers () {
      let headers = [];
      if (!this.isSingleCourtMode)
      {
        headers.push({ text: this.$t('courtCase.court'), value: 'caseHeader.courtID', sortable: false });
      }

      headers.push({ text: this.$t('courtCase.case'), value: 'caseHeader.caseNumber', sortable: false });
      headers.push({ text: this.$t('courtCase.caseTitle'), value: 'caseHeader.caseTitle', sortable: false });
      headers.push({ text: this.$t('courtCase.caseClassification'), value: 'caseHeader.caseClassification', sortable: false });
      headers.push({ text: this.$t('courtCase.filedDate'), value: 'caseHeader.filedDate', sortable: false });

      return headers;
    },
    isSingleCourtMode () {
      return applicationStore.isSingleCourtMode;
    }
  },
  methods: {
    getCourtByExternalID (externalCourtID) {
      return applicationStore.getCourtByExternalID(externalCourtID);
    },
    getCaseViewLink (bean) {
      return {
        name: 'caseView',
        params: {
          courtID: this.getCourtByExternalID(bean.caseHeader.courtID).resourceID,
          caseUUID: bean.caseHeader.caseInstanceUUID
        }
      };
    }
  }
};
</script>